import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { makeStyles, withStyles } from '@material-ui/core/styles';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles((theme) => ({
  infoDialogTitle: {
    '& .MuiTypography-root ': {
      color: '#0033cc',
      fontWeight: 600,
      fontSize: 18,
      textTransform: 'capitalize'
    }
  },
  infoDialogText: {
    color: '#0b1323',
    fontSize: 14
  },
  closeButton: {
    color: '#0b1323',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: 14,
    opacity: 0.5
  },
  infoDialog: {
    //maxWidth:348,
    //minWidth:348
    '& .MuiPaper-root': {
      maxWidth: 348
    }
  }
}));
export default function InfoDialog(props) {
  const { cancelText, confirmText, confirmMessage, confirmTitle, confirmOpen, onClose } = props;
  const [open, setOpen] = React.useState(confirmOpen);
  const [confirmMessageValue, setConfirmMessageValue] = useState("");

  useEffect(() => {

    if (confirmMessage.includes(".")) {
      let split = confirmMessage.split('.');
      setConfirmMessageValue(split);
    } else {
      setConfirmMessageValue(confirmMessage);
    }

  }, [confirmOpen, confirmMessage]);

  const classes = useStyles();
  const handleNo = () => {
    setOpen(false)
    onClose(false);
  };
  const handleYes = () => {
    setOpen(false);
    onClose(true);
  };
  const handleClose = () => {
  }
  return (
    <div>
      <Dialog
        open={open}
        //maxWidth='xs'
        className={classes.infoDialog}
        TransitionComponent={Transition}
        // keepMounted
        onClose={handleClose}
        aria-labelledby="InfoDialog-dialog-slide-title"
        aria-describedby="InfoDialog-dialog-slide-description"
        disableEscapeKeyDown={true}
        onEscapeKeyDown={handleYes}
      >
        <DialogTitle id="InfoDialog-dialog-slide-title" className={classes.infoDialogTitle}>{confirmTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="InfoDialog-dialog-slide-description" className={classes.infoDialogText}>
            {typeof (confirmMessageValue) == 'object' &&
              confirmMessageValue.map((value) => (
                <div>{value}.</div>
              ))
            }
            {typeof (confirmMessageValue) != 'object' &&
              <div>{confirmMessageValue}.</div>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleNo} color="primary">
            {cancelText?cancelText:'No'}
          </Button> */}
          <Button onClick={handleYes} className={classes.closeButton}>
            {confirmText ? confirmText : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}